import draggable from 'vuedraggable'

export default {
  components: {
    draggable,
  },
  data: () => ({
    is_dragging: false,
  }),

  methods: {
    handleDragStart(e){
      console.log("start")
      this.is_dragging = true
    },
    handleDragStop(e){
      console.log("stop")
      this.is_dragging = false
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    },
  }
};